import axios from 'axios'
import Utils from '@/common/utils'

const url = process.env.VUE_APP_BLUENV !== 'development' ? `${process.env.VUE_APP_BASE_API}/api` : '/api'
const headers = { Authorization: Utils.setLocalToken() }

export default class SessionService {
  static async login (body) {
    const { data } = await axios.post(`${url}/login`, body, {
      headers,
      withCredentials: true
    })
    return data
  }

  static async logout () {
    const { data } = await axios.post(`${url}/logout`, {
      headers,
      withCredentials: true
    })
    return data
  }

  static async getSession () {
    const { data } = await axios.get(`${url}/getSession`, {
      headers,
      withCredentials: true
    })
    return data
  }

  static async recoverPassword (email) {
    const { data } = await axios.post(`${url}/recoverPass/`, email, { headers })
    return data
  }

  static async checkRecoveryKey (recoveryData) {
    const { data } = await axios.post(`${url}/checkRecoveryKey/`, recoveryData, { headers })
    return data
  }

  static async setNewPassword (newData) {
    const { data } = await axios.post(
      `${url}/setNewPassword/`,
      newData,
      { headers }
    )

    return data
  }
}
